import Layer from './Layer';
import WiringArrowsImage from '../images/WiringArrowsImage';
import WiringImage from '../images/WiringImage';

const wiringLayer: Layer = {
  ArrowsImage: WiringArrowsImage,
  PlaneImage: WiringImage,
  anchorPositionX: 0.12,
  anchorPositionY: 0.6712,
  collapsedOffsetY: -0.181,
  description: `
    Buried wiring layer connects to the other planes through superconducting thru-substrate vias,
    providing the flexibility to efficiently route signals to the qubit plane with low crosstalk.
  `,
  name: 'Wiring plane',
  openOffsetY: -0.25,
  type: 'openable',
};

export default wiringLayer;
